import React from "react";

const AiLogoWithoutBg = () => (
	<svg
		width="24"
		height="25"
		viewBox="0 0 24 25"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<rect
			x="1"
			y="1.5"
			width="22"
			height="22"
			rx="6.2"
			fill="url(#paint0_radial_3042_51018)"
		/>
		<rect
			x="1"
			y="1.5"
			width="22"
			height="22"
			rx="6.2"
			stroke="url(#paint1_linear_3042_51018)"
			strokeWidth="2"
		/>
		<path
			d="M12.675 14.589C12.675 14.8577 12.714 15.057 12.792 15.187C12.87 15.3083 13 15.3993 13.182 15.46L12.792 16.682C12.3847 16.6473 12.051 16.552 11.791 16.396C11.5397 16.24 11.3447 15.9973 11.206 15.668C10.7553 16.3613 10.0663 16.708 9.139 16.708C8.45433 16.708 7.90833 16.513 7.501 16.123C7.10233 15.7243 6.903 15.2087 6.903 14.576C6.903 13.822 7.176 13.2457 7.722 12.847C8.268 12.4483 9.05233 12.249 10.075 12.249H10.868V11.911C10.868 11.4863 10.7727 11.1917 10.582 11.027C10.3913 10.8623 10.075 10.78 9.633 10.78C9.14767 10.78 8.541 10.9013 7.813 11.144L7.397 9.90899C8.255 9.57099 9.10433 9.40199 9.945 9.40199C10.881 9.40199 11.57 9.60566 12.012 10.013C12.454 10.4117 12.675 11.0097 12.675 11.807V14.589ZM9.646 15.382C10.166 15.382 10.5733 15.1263 10.868 14.615V13.302H10.257C9.26033 13.302 8.762 13.6747 8.762 14.42C8.762 14.7233 8.83567 14.9617 8.983 15.135C9.139 15.2997 9.36 15.382 9.646 15.382ZM16.3654 9.60999V16.5H14.5194V9.60999H16.3654ZM15.4294 6.06099C15.7587 6.06099 16.0274 6.16499 16.2354 6.37299C16.452 6.57233 16.5604 6.82799 16.5604 7.13999C16.5604 7.45199 16.452 7.71199 16.2354 7.91999C16.0274 8.11933 15.7587 8.21899 15.4294 8.21899C15.1 8.21899 14.8314 8.11933 14.6234 7.91999C14.4154 7.71199 14.3114 7.45199 14.3114 7.13999C14.3114 6.82799 14.4154 6.57233 14.6234 6.37299C14.8314 6.16499 15.1 6.06099 15.4294 6.06099Z"
			fill="#3E1367"
		/>
		<defs>
			<radialGradient
				id="paint0_radial_3042_51018"
				cx="0"
				cy="0"
				r="1"
				gradientUnits="userSpaceOnUse"
				gradientTransform="translate(3 5) rotate(42.5104) scale(24.4182 24.6825)"
			>
				<stop stopColor="#F5FFFC" />
				<stop offset="1" stopColor="#F4EAFF" />
			</radialGradient>
			<linearGradient
				id="paint1_linear_3042_51018"
				x1="3"
				y1="4"
				x2="21.5"
				y2="21"
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#0EFFBB" />
				<stop offset="1" stopColor="#7904FF" />
			</linearGradient>
		</defs>
	</svg>
);

export default AiLogoWithoutBg;
